import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import "./moodboard-story-view.css";
import ReactJWPlayer from "react-jw-player";
import ContentComments from "../ContentComments";
import { IconButton } from "@material-ui/core";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";
import ReactPlayer from "react-player";
import YoutubePlayer from "../YoutubePlayer/YoutubePlayer";
import IspotPlayer from "../IspotPlayer/IspotPlayer";
import { InstagramEmbed } from "react-social-media-embed";
import LinkedInCard from "../LinkedInCard";

const MoodboardStoryView = forwardRef(({ selectedIndex = 1, data }, ref) => {
  let t = selectedIndex - 1;
  const [index, setIndex] = useState(t);
  const [showComment, setShowComment] = useState(false);
  const [disablePrevious, setDisablePrevious] = useState(t > 1 ? false : true);
  const [disableNext, setDisableNext] = useState(
    t === data.length ? true : false
  );
  const [selectedMoodboard, setSelectedMoodboard] = useState(data[t]?._id);

  useEffect(() => {
    renderDisplaying();
    manageButtons();
    let t = data[index];
    if (t) setSelectedMoodboard(t._id);
  }, [index]);

  const onToggleComment = () => {
    setShowComment(!showComment);
  };

  useImperativeHandle(ref, () => ({
    onToggleComment: () => {
      onToggleComment();
    },
  }));

  useEffect(() => {
    function handlekeydownEvent(event) {
      const { key, keyCode } = event;
      if (keyCode == 37 && index > 0) {
        goPrevious();
      }
      if (keyCode == 39 && index < data.length - 1) {
        goNext();
      }
    }

    document.addEventListener("keyup", handlekeydownEvent);
    return () => {
      document.removeEventListener("keyup", handlekeydownEvent);
    };
  }, [index]);

  const renderDisplaying = () => {
    const item = data[index];
    const type = item?.type;
    const playingUrl = item?.fileUrl;
    if (type === "video") {
      if (playingUrl.includes("ispot.tv")) {
        return (
          <IspotPlayer
            url={playingUrl}
            style={{
              height: "550px",
              maxHeight: "550px",
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
            className="ispot-player-story-view"
          />
        );
      } else if (item.source === "instagram") {
        return <InstagramEmbed key={playingUrl} url={playingUrl} />;
      } else if (item.source === "twitter") {
        const tweetId = playingUrl.match(/status\/(\d+)/)?.[1];
        return tweetId ? (
          <iframe
            src={`https://platform.twitter.com/embed/Tweet.html?id=${tweetId}&theme=dark`}
            className="player"
            style={{ border: "none", minHeight: "400px" }}
            allowFullScreen
          />
        ) : null;
      } else if (item.source === "linkedin") {
        return <LinkedInCard key={playingUrl} url={playingUrl} />;
      } else if (playingUrl.includes("youtube.com/shorts")) {
        return <YoutubePlayer url={playingUrl} style={{ height: "550px" }} />;
      } else if (playingUrl.includes("youtube")) {
        let id = new URL(playingUrl).searchParams.get("v");
        let src = `https://www.youtube.com/embed/${id}`;
        return (
          <iframe
            id="player"
            className="player"
            src={src}
            key={playingUrl}
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        );
      } else if (playingUrl.includes("vimeo")) {
        let id = playingUrl.split("/").pop();
        let src = `https://player.vimeo.com/video/${id}`;
        return (
          <iframe
            id="player"
            className="player"
            src={src}
            key={playingUrl}
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        );
      } else {
        return (
          <ReactPlayer
            className="story-view-player"
            id={playingUrl.toString()}
            url={playingUrl}
            controls={true}
          />
        );
      }
    } else if (type === "docs") {
      return (
        <iframe
          id="player"
          className="player"
          style={{ width: "830px" }}
          src={playingUrl}
          key={playingUrl}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      );
    } else if (type === "audio") {
      return (
        <div style={{ margin: "20px", marginTop: "100px" }} key={playingUrl}>
          <audio
            controls
            className="audio-player w-100"
            src={playingUrl}
          ></audio>
        </div>
      );
    } else if (type === "image") {
      return (
        <img
          className="image-player"
          style={{ maxHeight: "550px" }}
          key={playingUrl}
          src={playingUrl}
        />
      );
    } else if (type === "website") {
      return (
        <>
          <img
            className="image-player mb-30"
            key={playingUrl}
            src={playingUrl}
          />
          <br />
          Title: {item.title}
          <br />
          Website:{" "}
          <a href={item.websiteUrl} target="_blank" className="btn btn-link">
            {item.websiteUrl}
          </a>
          <br />
          Description: {item.description}
        </>
      );
    } else if (type === "pexels-video") {
      return (
        <video className="player" key={playingUrl} controls poster={item.thumbnailUrl}>
          <source src={playingUrl} type="video/mp4" />
        </video>
      );
    }
  };

  const goPrevious = (e) => {
    //e.preventDefault();
    if (index > 0) {
      setIndex(index - 1);
    }

    manageButtons();
  };

  const goNext = (e) => {
    //e.preventDefault();
    if (index < data.length) {
      setIndex(index + 1);
    }

    manageButtons();
  };

  const manageButtons = () => {
    setDisablePrevious(true);
    setDisableNext(true);
    if (index > 0) setDisablePrevious(false);
    if (index < data.length - 1) setDisableNext(false);
  };

  if (data?.length === 0) {
    return null;
  }

  return (
    <div className="container-fluid text-center mt-20 third-view">
      <div className="container-fluid content-details ">
        <div className="row">
          <div className="col-1 text-center third-view-nav">
            <IconButton
              className={`nav-icon`}
              disabled={disablePrevious}
              onClick={goPrevious}
            >
              <ChevronLeft />
            </IconButton>
          </div>

          <div
            className="col-md-7 col-sm-12 text-left"
            style={{ flex: 1, maxWidth: "100%" }}
          >
            <div className="displaying-body">{data && renderDisplaying()}</div>
          </div>

          {showComment && (
            <div
              className="col-md-3 col-sm-12 text-left"
              style={{ paddingLeft: "20px", marginTop: "50px" }}
            >
              <ContentComments id={selectedMoodboard} />
            </div>
          )}

          <div className="col-1 text-center third-view-nav">
            <IconButton
              className={`nav-icon`}
              disabled={disableNext}
              onClick={goNext}
            >
              <ChevronRight />
            </IconButton>
          </div>
        </div>
      </div>
    </div>
  );
});

export default MoodboardStoryView;
